import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { IMPORT_VERSIONS_ACTIONS } from "./actions/ImportVersions";
import { escapeUnderscoreForAPI } from "utils/common";

import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";


export function reset(){
	return (dispatch) => {
		dispatch({
			type: IMPORT_VERSIONS_ACTIONS.RESET_IMPORT_VERSIONS_LIST,
		});

		return Promise.resolve({ success: true });
	};
}

export function fetchImportVersions(jobId, creativeIds){
	return (dispatch, getState) => {
		const state = getState();
		const { filterInfo = {
			rpp:25,
			page:1,
			sort: null,
		} } = state.importVersions;
		const params = { ...filterInfo };

		if(creativeIds && creativeIds.length){
			params.creativeIds = creativeIds.join(",");
		}

		if (params.searchTerm) {
			params.versionName = escapeUnderscoreForAPI(filterInfo.searchTerm);
		}

		// This endpoint does not expect advanceFilter and searchTerm
		delete params.searchTerm;
		delete params.advanceFilter;

		return dispatch({
			type: IMPORT_VERSIONS_ACTIONS.FETCH_IMPORT_VERSIONS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `ui/version/import/${jobId}/versions`,
				params,
				success: IMPORT_VERSIONS_ACTIONS.FETCH_IMPORT_VERSIONS_SUCCESS,
				error: IMPORT_VERSIONS_ACTIONS.FETCH_IMPORT_VERSIONS_ERROR,
			},
		});
	};
}

export function importVersions(data, withPreview = false) {
	const params = withPreview ? { dirty: true } : {};
	return (dispatch) => {
		return dispatch({
			type: IMPORT_VERSIONS_ACTIONS.IMPORT_VERSIONS_AJAX,
			AJAX: {
				url: `ui/version/import_temp`,
				method: "post",
				data,
				params,
				headers: { "Content-Type": "multipart/form-data" },
				success: IMPORT_VERSIONS_ACTIONS.IMPORT_VERSIONS_SUCCESS,
				error: IMPORT_VERSIONS_ACTIONS.IMPORT_VERSIONS_ERROR,
			},
			meta: SUPPRESS_SUCCESS_GROWL,
		});
	};
}

export function confirmImport(jobId){
	return (dispatch) => {
		return dispatch({
			type: IMPORT_VERSIONS_ACTIONS.CONFIRM_VERSION_IMPORT,
			AJAX: {
				url: `ui/version/import/${jobId}/confirm`,
				method: "post",
				success: IMPORT_VERSIONS_ACTIONS.CONFIRM_VERSION_IMPORT_SUCCESS,
				error: IMPORT_VERSIONS_ACTIONS.CONFIRM_VERSION_IMPORT_ERROR,
			},
		});
	};
}

export function confirmImportWithPreview(jobId) {
	return (dispatch, getState) => {
		// We need to assemble payload data in accordance with schema
		// that is expected by the API.
		// { creatives: [{ id, versions: [{id, name, variableConfig}] }] }
		const state = getState()
			, { items } = state.importVersions
			, { importVersionsRefinements } = state.refinements;

		// Accumulate versions by creative ids and blend in any refinement data
		const payloadCreativesMap = items.reduce((acc, item) => {
			const { creative, id, name, variableConfig } = item
				, creativeId = creative.id;

			//If there is no object with given creativeId in the map, create it
			let creativeItem = acc.get(creativeId);
			if (!creativeItem) {
				creativeItem = { id: creativeId, versions: []};
				acc.set(creativeId, creativeItem);
			}

			const version = { id, name, variableConfig: { ...variableConfig } };

			// Blend in refinement data (cropMetadata) if there is any
			const refinement = importVersionsRefinements[creativeId]?.[name]
				, refinedVariableConfig = refinement?.variableConfig;
			if (refinedVariableConfig) {
				Object.keys(version.variableConfig).forEach((key) => {
					const cropMetadata = refinedVariableConfig[key]?.cropMetadata;

					if (cropMetadata) {
						version.variableConfig[key].cropMetadata = cropMetadata;
					}
				});
			}

			// Add version to the creative item
			creativeItem.versions.push(version);
			return acc;
		}, new Map());

		const data = { creatives: [...payloadCreativesMap.values()]};
		return dispatch({
			type: IMPORT_VERSIONS_ACTIONS.CONFIRM_VERSION_IMPORT,
			AJAX: {
				url: `version/import/${jobId}/confirm-with-changes`,
				method: "post",
				data,
				success: IMPORT_VERSIONS_ACTIONS.CONFIRM_VERSION_IMPORT_SUCCESS,
				error: IMPORT_VERSIONS_ACTIONS.CONFIRM_VERSION_IMPORT_ERROR,
			},
		});
	};
}

const initialImportVersionsState = {
	success: true,
	items: [],

	totalPages: 1,
	totalItems: 0,

	isLoaded: false,
	hasErrorLoading: false,
	columnFilters: {
		active: {},
	},
};

const actionCreators = {
	reset,
	fetchImportVersions,
	importVersions,
	confirmImport,
};

const handlers = {
	[IMPORT_VERSIONS_ACTIONS.RESET_IMPORT_VERSIONS_LIST]: clearList,
	[IMPORT_VERSIONS_ACTIONS.FETCH_IMPORT_VERSIONS_AJAX]: isLoadingImportVersions,
	[IMPORT_VERSIONS_ACTIONS.FETCH_IMPORT_VERSIONS_SUCCESS]: initImportVersions,
	[IMPORT_VERSIONS_ACTIONS.FETCH_IMPORT_VERSIONS_ERROR]: initErrorImportVersions,
};

function clearList(state, action){
	return {
		...initialImportVersionsState,
		filterInfo: {
			page: 1,
		},
	};
}

function isLoadingImportVersions(state, action){
	return {
		...state,
		isLoaded: false,
	};
}

function initImportVersions(state, action){
	let { data } = action.payload;
	return {
		...state,
		...data,
		isLoaded: true,
		hasErrorLoading: false,
	};
}

function initErrorImportVersions(state, action){
	return {
		...state,
		isLoaded: true,
		hasErrorLoading: true,
	};
}

let reducerConfig = {
	typeRoot: "IMPORT_VERSIONS",
	initialState: initialImportVersionsState,
	actionTypes: IMPORT_VERSIONS_ACTIONS,
	actionCreators,
	handlers,
};

reducerConfig = addFiltering(reducerConfig);


export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const ImportVersions = reducerConfig.actionCreators;
